<template>
  <v-row
    justify="center"
    class="mt-4"
  >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Create New Org
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>$faTimes</v-icon>
          </v-btn>
          <v-toolbar-title>Create New Organization</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <template>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            class="pa-10"
          >
            <v-text-field
              v-model="org.name"
              label="Organization Name"
              :rules="[v => !!v || 'Org name is required']"
              type="text"
              required
            />

            <v-text-field
              v-model="user.email"
              :rules="emailRules"
              label="User E-mail"
              type="email"
              required
            />

            <v-text-field
              v-model="user.firstName"
              :rules="[v => !!v || 'First name is required']"
              label="User First Name"
              type="text"
              required
            />

            <v-text-field
              v-model="user.lastName"
              :rules="[v => !!v || 'Last name is required']"
              label="User Last Name"
              type="text"
              required
            />

            <v-text-field
              v-model="user.phone"
              :rules="[v => !!v || 'Phone is required']"
              label="User Phone"
              type="phone"
              required
            />

            <v-btn
              :disabled="!valid"
              color="primary"
              class="mr-4"
              block
              @click="submitOrgForm"
            >
              Submit
            </v-btn>
          </v-form>
        </template>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    data: () => ({
      dialog: false,
      valid: false,
      user: {
        email: '',
        firstname: '',
        lastname: '',
        phone: '',
      },
      org: {
        orgName: '',
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    }),
    methods: {
      submitOrgForm () {
        const payload = this.generatePayload()
        this.$store.dispatch('Organizations/createNewOrg', payload).then(() => { this.dialog = false })
      },
      generatePayload () {
        if (!this.valid) return
        return {
          organization: {
            name: this.org.name,
          },
          user: {
            email: this.user.email.trim(),
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            phone: this.user.phone,
            role: 'external',
          },
        }
      },
    },
  }
</script>
<style lang="scss">

</style>
